import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import ContactForm from '../components/ContactForm';
import { useGetProductsQuery } from '../slices/productsApiSlice';
import ProductPresential from '../components/ProductPresential';
import { useTranslation } from 'react-i18next';

const HomeScreenPresential = () => {
  const { pageNumber, keyword } = useParams();
  const { t } = useTranslation();

  const { data, isLoading, error } = useGetProductsQuery({
    pageNumber,
    keyword,
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          <div className='page-heading'>
            <h1>{t('homeTitle')}</h1>
            <p>Formations en présentiel pour évoluer avec Licorne Academy.</p>
          </div>

          <Row>
            {data.products.map(
              (product) =>
                product.type === 0 && (
                  <Col
                    key={product._id}
                    sm={12}
                    md={6}
                    lg={4}
                    xl={3}
                    className='product-col'
                  >
                    <div className='product-wrapper' data-product-id={product._id}>
                      <ProductPresential product={product} />
                    </div>
                  </Col>
                )
            )}
          </Row>
          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword ? keyword : ''}
          />
          <br />
          <br />
          <ContactForm />
        </>
      )}
    </>
  );
};

export default HomeScreenPresential;
